export enum EPipelineAttachmentBuildStep {
  PABS_PlacementAndDirection,
  PABS_AdjustRotation,
}
